export const getVariantStyles = (variant, theme) => {
  const tokens = {
    default: {
      backgroundColor: theme.color['fill-surface-raised'],
      border: `${theme.borderWidth['100']} dashed ${theme.color['fill-accent-neutral-hover']}`,
      color: theme.color['icon-core-default'],
      iconColor: 'icon-core-default'
    },
    hover: {
      backgroundColor: theme.color['fill-info-subtle'],
      border: `${theme.borderWidth['100']} dashed ${theme.color['border-info-default']}`,
      color: theme.color['text-core-default'],
      iconColor: 'fill-info-default'
    },
    processing: {
      backgroundColor: theme.color['fill-surface-raised'],
      border: `${theme.borderWidth['100']} solid ${theme.color['fill-surface-raised']}`,
      color: theme.color['text-core-default'],
      iconColor: 'icon-core-default'
    },
    selected: {
      backgroundColor: theme.color['fill-surface-raised'],
      border: `${theme.borderWidth['100']} solid ${theme.color['fill-surface-raised']}`,
      color: theme.color['text-core-default'],
      iconColor: 'icon-core-default'
    },
    error: {
      backgroundColor: theme.color['fill-alert-subtle'],
      border: `${theme.borderWidth['100']} dashed ${theme.color['border-alert-default']}`,
      color: theme.color['text-core-default'],
      iconColor: 'icon-alert-default'
    },
    success: {
      backgroundColor: theme.color['fill-positive-subtle'],
      border: `${theme.borderWidth['100']} dashed ${theme.color['border-positive-default']}`,
      color: theme.color['text-core-default'],
      iconColor: 'fill-positive-default'
    }
  };
  return tokens[variant];
};
export const getIconSize = size => {
  switch (size) {
    case 'medium':
    case 'md':
    case 'large':
    case 'lg':
      return '800';
    case 'xs':
    case 'xl':
    case 'xxl':
    case 'small':
    case 'sm':
    default:
      return '600';
  }
};